import { createApi } from "@reduxjs/toolkit/query/react";
import { oneCBaseQuery, readOneCBaseUrl } from "./baseQuery";
import { buildOneCUrl, isAccountingUrl, isENgoOwnedAccountingUrl, resolveOneCRequest } from "./routing";
import { resolveAccountingMock } from "./mockSource";

export const oneCApi = createApi({
  reducerPath: "oneCApi",
  baseQuery: oneCBaseQuery,
  tagTypes: [],
  endpoints: () => ({}),
});

export { oneCBaseQuery, readOneCBaseUrl, resolveOneCRequest, isAccountingUrl, buildOneCUrl, resolveAccountingMock, isENgoOwnedAccountingUrl };
export type { OneCDecision } from "./routing";
